import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Rx';
import { Injectable } from '@angular/core';

interface CacheContent {
  expiry: number;
  value: any;
}

@Injectable()
export class CacheService {

  private cache: Map<string, CacheContent> = new Map<string, CacheContent>();
  private inFlightObservables: Map<string, Subject<any>> = new Map<string, Subject<any>>();
  readonly DEFAULT_MAX_TIME: number = 300000;

  get(key: string, fallback?: Observable<any>, maxTime?: number): Observable<any> | Subject<any> {

    if (this.hasValidCachedValue(key)) {
      return Observable.of(this.cache.get(key).value);
    }

    if (!maxTime) {
      maxTime = this.DEFAULT_MAX_TIME;
    }

    if (this.inFlightObservables.has(key)) {
      return this.inFlightObservables.get(key);
    } else if (fallback && fallback instanceof Observable) {
      this.inFlightObservables.set(key, new Subject());
      return fallback.do((value) => { this.set(key, value, maxTime); });
    } else {
      return Observable.throw('The key is not in Cache');
    }

  }

  set(key: string, value: any, maxTime: number = this.DEFAULT_MAX_TIME): void {

    this.cache.set(key, { value: value, expiry: Date.now() + maxTime });
    this.notifyInFlightObservers(key, value);
  }
  
  has(key: string): boolean {
    return this.cache.has(key);
  }

  private notifyInFlightObservers(key: string, value: any): void {

    if (this.inFlightObservables.has(key)) {

      const inFlight = this.inFlightObservables.get(key);
      const observersCount = inFlight.observers.length;
      if (observersCount) {
        inFlight.next(value);
      }

      inFlight.complete();
      this.inFlightObservables.delete(key);
    }
  }

  private hasValidCachedValue(key: string): boolean {
    if (this.cache.has(key)) {
      if (this.cache.get(key).expiry < Date.now()) {
        this.cache.delete(key);
        return false;
      }
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/cache.service.ts